import { constants, Investment, Investor, queries } from 'procura-shared';
import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useCollectionData, useDocumentData } from 'react-firebase-hooks/firestore';
import { useTranslation } from 'react-i18next';
import { useInvestmentInvestors } from '../api/calls/useInvestmentInvestors';
import firebase from '../api/firebase';
import { Dashboard, DetailsTable, InvestmentInfo, InvestmentsTable } from '../components/Components';
import '../styles/dashboard-page.less';
import { useLocalStorage } from '../utilities/Hooks';
import { setDelayed } from '../utilities/Utilities';

export const DashboardPage = () => {
  const { t } = useTranslation();
  const [user] = useAuthState(firebase.auth());

  const [selectedInvestment, setSelectedInvestment] = useState<Investment>();
  const [selectedInvestmentLoading, setSelectedInvestmentLoading] = useState<boolean>(false);

  const [investmentsUseTable, setInvestmentsUseTable] = useLocalStorage('userSettings-investmentsUseTable', false);

  const [fbInvestments, fbInvestmentsLoading] = useCollectionData<Investment>(
    queries.investorInvestmentsQuery(user?.uid),
    {
      idField: 'id',
    }
  );

  const [fbSelectedinvestmentInvestors, fbSelectedinvestmentInvestorsLoading] = useInvestmentInvestors(
    selectedInvestment?.investors
  );

  const [fbInvestor, fbInvestorLoading] = useDocumentData<Investor>(queries.investorQuery(user?.uid), {
    idField: 'id',
  });

  useEffect(() => {
    if (fbInvestments ?? [].length > 0) {
      setSelectedInvestment(fbInvestments[0]);
    }
  }, [fbInvestments]);

  return (
    <Dashboard>
      <Dashboard.Loader loading={selectedInvestmentLoading} />
      <Dashboard.Main
        titleName={fbInvestor?.name}
        sideActive={selectedInvestment != null}
        panels={[
          {
            title: t('myData'),
            content: (
              <DetailsTable
                adminMode={true}
                loading={fbInvestorLoading}
                details={fbInvestor}
                keys={constants.INVESTOR_KEYS}
              />
            ),
          },
          {
            title: t('myInvestments'),
            content: (
              <InvestmentsTable
                scroll
                loading={fbInvestmentsLoading}
                search
                investments={fbInvestments}
                table={investmentsUseTable}
                changeUseTable={(state) => setInvestmentsUseTable(state)}
                onSelect={(investment) => setDelayed(investment, setSelectedInvestment, setSelectedInvestmentLoading)}
              />
            ),
          },
        ]}
      />
      <Dashboard.Side
        title={selectedInvestment?.name}
        onClose={() => setSelectedInvestment(null)}
        active={selectedInvestment != null}>
        <InvestmentInfo
          investment={selectedInvestment}
          investors={fbSelectedinvestmentInvestors}
          loading={selectedInvestmentLoading || fbSelectedinvestmentInvestorsLoading}
        />
      </Dashboard.Side>
    </Dashboard>
  );
};
